<template>
<div class="">
<user-top></user-top>
<div class="ht tc mt50">家庭关系<span>（填写父母、配偶及子女）</span></div>
<div class="millia">
<ul class="expList">
<li v-for="(familyLists,id) of familyList" :key="id" :id="familyLists.id">
<p><label>姓名：</label>{{familyLists.realname}}</p>
<p><label>手机号码：</label>{{familyLists.phone}}</p>
<p><label>成员关系：</label>{{familyLists.relation}}</p>
<p><label>工作单位：</label>{{familyLists.work_add}}</p>
<div class="btGroup">
<!-- <span class="editBt">编辑</span> -->
<span class="deleteBt" @click="FamilyDelete(familyLists.id)">删除</span>
</div>
</li>
</ul>
<div class="layui-form groupList" lay-filter="familySave">
<form action="">
<ul class="userInfo">
<li>
<div class="layui-input-inline">
<input type="text" name="relation" placeholder="请输入成员关系" class="layui-input" lay-verify="required">
</div>
<div class="layui-input-inline ml10">
<input type="text" name="realname" placeholder="请输入成员姓名" class="layui-input" lay-verify="required">
</div>
</li>
<li>
<input type="text" name="phone" placeholder="请输入家庭成员联系电话" class="layui-input" lay-verify="required|phone">
</li>
<li>
<input type="text" name="work_add" placeholder="请输入家庭成员工作单位" class="layui-input"  lay-verify="required">
</li>
<li>
<div class="mt30 pb40">
<button type="button" lay-submit class="layui-btn layui-btn-fluid layui-btn-normal" lay-filter="familySave">添加家庭成员</button>
</div>
</li>
</ul>
</form>
</div>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: "FamilyGroup",
    inject: ["reload"],
    components:{
        UserTop
    },
    data () {
        return {
            //familyData
            familyList:{},
            familyGroup:{},
        }
    },
    mounted (){
        this.getFamilyList();
        //表单相关
        var that = this; 
        layui.use('form', function(){
            var $ = layui.$;
            var form = layui.form;
            form.on('submit(familySave)', function(data){
                var BasicDatas = JSON.parse(JSON.stringify(data.field));               
                that.familyList = BasicDatas;
                that.familySave();
            });
        });
    },
    methods: {
        //家庭成员信息提交
        familySave(){
            let url = "api/user/saveFamily";
            var param = {
                relation:this.familyList.relation,
                realname:this.familyList.realname,
                phone:this.familyList.phone,
                work_add:this.familyList.work_add,
            }            
            this.$ajax.post(url,param).then(function (response) {
                if (response.data.status==1) {
                    //alert("家庭成员保存成功成功");
                    this.reload();  
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取用户家庭关系信息
        getFamilyList() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.familyList = response.data.data.family;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //删除家庭关系
        FamilyDelete(id){
            let url = "api/user/delFamily";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("家庭成员删除成功!");
                    this.reload();
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        }, 
    }
}
</script>